import React, { useRef, useState, useEffect, act } from 'react';
import {
  Button,
  Flex,
  Box,
  Text,
  InputGroup,
  InputLeftElement,
  Input,
  Collapse,
  Tooltip,
  Img,
  HStack,
  Textarea,
  VStack,
} from '@chakra-ui/react';
import { IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import taskLogo from './Task.svg';
import { ReactComponent as TaskTrackerIcon } from './tasktracker.svg';
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { ReactComponent as HomeIcon } from "./Home.svg"

import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useWebSocket } from '../../internal/messaging/WebSocketContext.js';
import { PushPinOutlined, LocalHospitalOutlined, LocalLibraryOutlined, LocalLibrary, DeleteOutlined, Delete, EditOutlined, Check, Close, PushPin, IntegrationInstructionsOutlined, AnalyticsOutlined } from '@mui/icons-material';
import apiClient from '../../clients/apiClient.js';
import NewTaskModal from './NewTaskModal/NewTaskModal';
import thalamuslogo from './thalamusLogo2.png';

const LeftMenu = ({handleClick}) => {
  const [isPinnedOpen, setIsPinnedOpen] = React.useState(true);
  const [isRecentTasksOpen, setIsRecentTasksOpen] = React.useState(true);
  // const [searchQuery, setSearchQuery] = React.useState('');
  const [disableTooltip, setDisableTooltip] = React.useState(false);
  const navigate = useNavigate();
  const { tasks, filterTasks, pinnedTasks, refreshTasks } = useWebSocket();
  const { taskId } = useParams();
  const location = useLocation();
  const [isTaskOpen, setIsTaskOpen] = useState(false);
  const [searchPattern, setSearchPattern] = useState('');

  const filteredTasks = (tasks || []);

  return (
    <Flex
      direction="column"
      justifyContent="space-between"
      // justifyItems={"flex-start"}
      height="100%"
      // overflow="hidden"
      px={6}
      paddingTop={"24px"}
      mt="0px"
      paddingRight="24px"
      gap={0}
      backgroundColor={"white"}
      // data-scrollable="true"
      // maxH={"1vh"}
    >

      {/* Top Section */}
      {/* <Box maxHeight={`calc(100% - 48px)`} overflow={"hidden"}> */}
      <Box>
        <HStack onClick={() => navigate('/')} style={{ cursor: 'pointer' }}>
        <img 
            src={thalamuslogo} 
            style={{ 
              height: ['32px', ' 40px', '48px'], // Responsive height for different breakpoints
            }}
          />
          {/* <Text 
            fontSize={['20px', '22px', '24px']} // Responsive font sizes for different breakpoints
            fontWeight="bold" 
            color="#1d1d1d"
          >
            Thalamus AI
          </Text> */}
        </HStack>
        <Button
          marginTop={"32px"}
          align={"flex-start"}
          justifyContent={"left"}
          // width={"content-fill"}
          variant="link"
          // w={"auto"}
          width="108px"
          // maxW={"unset"}
          color="#1d1d1d"
          bg={"#F6F8FA"}
          boxShadow="0px 1px 4px rgba(29, 29, 29, 0.25)"
          _hover={{ boxShadow: "0px 2px 6px rgba(29, 29, 29, 0.3)" }}
          fontWeight={"medium"}
          borderRadius={"8px"}
          onClick={() => {
            handleClick() 
            setIsTaskOpen(true)
          }}
        >
          <IconButton 
            aria-label="New Task"
            sx={{
              borderRadius: "8px",
              borderColor: "#5d5d5d",
              padding: '3px',
              "&:hover":{backgroundColor: "transparent"},
            }}
          >
            <AddOutlinedIcon sx={{padding:0, color:"#5d5d5d", fontSize: 24}} />
          </IconButton>
          <Text 
            paddingLeft={"1px"} 
            paddingRight={"16px"} 
            paddingY="8px" 
            fontWeight="regular" 
            color="#1d1d1d" 
            fontSize="15px" 
            fontFamily="sans-serif"
          >
            New task
          </Text>
        </Button>
        <Box
          display="flex"
          align={"flex-start"}
          alignItems="center"
          gap={2}
          // marginTop={0}
          // px={2}
          py="8px"
          mt="16px"
          // mb="8px"
          // pt="24px"
          borderRadius="md"
          cursor="pointer"
          _hover={{
            bg: "#E7F1FC",
          }}
          bg={location.pathname === '/' ? "#E7F1FC" : 'transparent'}
          color={
            location.pathname === '/' ? 'blue.500' : 'gray.800'
          }
          onClick={() => navigate('/')}
          fontWeight={"medium"}
          
        > 
          <HomeIcon
            alt="home"
          />

          <Text 
            px={0} 
            color={location.pathname === '/' ? "#1d1d1d" : "#1d1d1d"} 
            fontWeight={location.pathname === '/' ? "semibold" : "regular"} 
            fontSize="15px" 
            fontFamily="sans-serif"
          >
            Home
          </Text>
        </Box>

        <Button
          // as={HStack}
          display={"flex"}
          justifyContent={"space-between"}
          variant="link"
          w="100%"
          // w="fit-content"
          // onClick={onOpen}
            onClick={() => navigate('/my-library')}
            color="#1d1d1d"
            fontWeight={500}
            size={'lg'}
            m={0}
            marginTop="8px"
            _hover={{
            bg:"#E7F1FC"
            }}
            bg={location.pathname.startsWith('/my-library') ? "#E7F1FC" : 'transparent'}
          >
            <HStack justifyContent="flex-start">
            <IconButton aria-label="library" 
            sx={{
              paddingX:0, paddingRight:0, "&:hover":{backgroundColor: "transparent"}
            }}>
              <LocalLibraryOutlined sx={{ padding:0, fontSize: 22, color: "#5d5d5d" }}/>
            </IconButton>
            <Text paddingX="4px" color="#1d1d1d" fontSize="15px" fontFamily="sans-serif"
              fontWeight={location.pathname.startsWith('/my-library') ? "semibold" : "regular"}
            >Library</Text>
            </HStack>
        </Button>
        <Box
          display="flex"
          align={"flex-start"}
          alignItems="center"
          gap={2}
          // marginTop={0}
          // px={2}
          py="8px"
          mt="8px"
          // mb="8px"
          // pt="24px"
          borderRadius="md"
          cursor="pointer"
          _hover={{
            bg: "#E7F1FC",
          }}
          bg={location.pathname === '/task-tracker' ? "#E7F1FC" : 'transparent'}
          color={
            location.pathname === '/task-tracker' ? 'blue.500' : 'gray.800'
          }
          onClick={() => navigate('/task-tracker')}
          fontWeight={"medium"}
          
        > 
          <TaskTrackerIcon
            alt="task tracker"
          />

          <Text px={0} color={location.pathname === '/task-tracker' ? "#1d1d1d" : "#1d1d1d"} fontWeight={location.pathname === '/task-tracker' ? "semibold" : "regular"} fontSize="15px" fontFamily="sans-serif">
            Task tracker
          </Text>
        </Box>
      </Box>
      <Box flex="1" maxW={"100%"} overflowX={"hidden"} width="100%" data-scrollable="true" >
        {pinnedTasks?.length > 0 ? (
          <Box flex="1" display="flex" flexDirection="column" maxHeight={`calc(1000%)`}>
            <Flex
              // p={0}
              onClick={() => setIsPinnedOpen((prevState) => !prevState)}
              // variant="link"
              // w="fit-content"
              justifyContent={'space-between'}
              cursor={'pointer'}
              color="#1D1D1D"
              mt="10px"
              // mb="8px"
              alignItems={'center'}
            >
              <Text fontWeight="medium" padding="0px" paddingTop="8px" paddingBottom={"4px"} fontSize="15px" fontFamily="sans-serif">Pinned Tasks</Text>
              <IconButton
                sx={{
                  borderRadius: "20%",
                  paddingX: '0px',
                  paddingY: '0px',
                  "&:hover":{backgroundColor: "transparent"},
                }}>
                {isPinnedOpen ? <ExpandMoreIcon sx={{padding:0, color:"#a1b3d3", fontSize: 24}}/> : <ExpandLessIcon sx={{padding:0, color:"#a1b3d3", fontSize: 24}}/>}
              </IconButton>
            </Flex>
            <Collapse in={isPinnedOpen} animateOpacity>
              <Box overflow="auto" flex="1" maxHeight={`calc(100%)`} data-scrollable="true" 
                  onScroll={() => setDisableTooltip(true)}
                  onMouseEnter={() => setDisableTooltip(false)}
                >
                {pinnedTasks.map((task) => (
                  <TaskBox 
                    task={task} 
                    taskId={taskId} 
                    handleClick={handleClick} 
                    disableTooltip={disableTooltip}
                    refreshTasks={refreshTasks}
                    pinnedTasks={pinnedTasks}
                  />
                ))}
              </Box>
            </Collapse>
          </Box>
        ) : null}
        {tasks?.length > 0 || searchPattern ? (
          <Box flex="1" display="flex" flexDirection="column" maxHeight={`calc(1000%)`}>
          <Flex
            // p={0}
            onClick={() => setIsRecentTasksOpen((prevState) => !prevState)}
            // variant="link"
            // w="fit-content"
            justifyContent={'space-between'}
            cursor={'pointer'}
            color="#1D1D1D"
            mt="10px"
            mb="8px"
            alignItems={'center'}
          >
            <Text fontWeight="medium" padding="0px" paddingY="8px" fontSize="15px" fontFamily="sans-serif">Recent tasks</Text>
            <IconButton
              sx={{
                borderRadius: "20%",
                paddingX: '0px',
                paddingY: '0px',
                "&:hover":{backgroundColor: "transparent"},
              }}>
              {isRecentTasksOpen ? <ExpandMoreIcon sx={{padding:0, color:"#a1b3d3", fontSize: 24}}/> : <ExpandLessIcon sx={{padding:0, color:"#a1b3d3", fontSize: 24}}/>}
            </IconButton>
          </Flex>
          <Collapse in={isRecentTasksOpen} animateOpacity>
            <InputGroup size="sm" borderRadius="8px" mb="8px" overflow="hidden" borderColor={"#e5e5e5"} height={"40x"}>
              <InputLeftElement pointerEvents="none" h="40px">
                <IconButton>
                  <SearchIcon fontSize="24px"/>
                </IconButton>
              </InputLeftElement>
              <Input
                h="40px"
                borderRadius="8px"
                placeholder="Search by name"
                onChange={(e) => {setSearchPattern(e.target.value); filterTasks(e.target.value)}}
                value={searchPattern}
                sx={{
                  '::placeholder': {
                    fontSize: '14px',
                    fontWeight: 'regular',
                    fontFamily: "sans-serif"
                  },
                }}
              />
            </InputGroup>
            {tasks?.length > 0 ? (
              <Box overflow="auto" flex="1" maxHeight={`calc(100%)`} data-scrollable="true" 
                  onScroll={() => setDisableTooltip(true)}
                  onMouseEnter={() => setDisableTooltip(false)}
                >
                {filteredTasks.map((task) => (
                  <TaskBox 
                    task={task} 
                    taskId={taskId} 
                    handleClick={handleClick} 
                    disableTooltip={disableTooltip}
                    refreshTasks={refreshTasks}
                    pinnedTasks={pinnedTasks}
                  />
                ))}
            </Box>
            ) : null}
          </Collapse>
        </Box>
        ) : null}
      </Box>

      {/* Sticky Bottom Section */}
      <Flex
        direction="column"
        gap={2}
        // position="sticky"
        // bottom={0}
        py={"16px"}
        paddingTop={"12px"}
        // bg={'#f6fafe'}
        borderTop="1px"
        borderColor={"#e6eaee"}
      >
        <Button
          as={HStack}
          display={"flex"}
          // justifyContent={"space-between"}
          variant="link"
          w="100%"
          // w="fit-content"
          // onClick={onOpen}
          // onClick={() => navigate('/integrations')}
          color="#1d1d1d"
          maxWidth={"100%"}
          fontWeight={500}
          size={'lg'}
          m={0}
          _hover={{
            bg:"#E7F1FC"
          }}
          bg={location.pathname === '/reports' ? "#E7F1FC" : 'transparent'}
        >
          <HStack justifyContent="flex-start" maxW={`calc(100% - 32px)`}>
            <IconButton aria-label="reports" 
            sx={{
              paddingX:0, paddingRight:0, "&:hover":{backgroundColor: "transparent"}
            }}>
              <AnalyticsOutlined sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
            </IconButton>
            <Text paddingX="4px" color="#1d1d1d" fontSize="15px" fontFamily="sans-serif"
              fontWeight={location.pathname === '/reports' ? "semibold" : "regular"}
              flexShrink={1}
              minW={"0px"}
              overflowX={"hidden"}
              // isTruncated
              // maxW={`calc(100% - 48px - 24px)`}
            >Reporting & Analytics</Text>
          </HStack>

          <IconButton aria-label="reports" 
            justify="flex-end"
            sx={{
              paddingX:0, paddingRight:0, "&:hover":{backgroundColor: "transparent"}
            }}>
            <KeyboardArrowRightIcon sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
          </IconButton>
        </Button>
        <Button
          // as={HStack}
          display={"flex"}
          justifyContent={"space-between"}
          variant="link"
          w="100%"
          // w="fit-content"
          // onClick={onOpen}
          onClick={() => navigate('/integrations')}
          color="#1d1d1d"
          fontWeight={500}
          size={'lg'}
          m={0}
          _hover={{
            bg:"#E7F1FC"
          }}
          bg={location.pathname === '/integrations' ? "#E7F1FC" : 'transparent'}
        >
          <HStack justifyContent="flex-start">
            <IconButton aria-label="integrations" 
            sx={{
              paddingX:0, paddingRight:0, "&:hover":{backgroundColor: "transparent"}
            }}>
              <IntegrationInstructionsOutlined sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
            </IconButton>
            <Text paddingX="4px" color="#1d1d1d" fontSize="15px" fontFamily="sans-serif"
              fontWeight={location.pathname === '/intergations' ? "semibold" : "regular"}
            >Integrations</Text>
          </HStack>

          <IconButton aria-label="integrations" 
          justify="flex-end"
          sx={{
            paddingX:0, paddingRight:0, "&:hover":{backgroundColor: "transparent"}
          }}>
            <KeyboardArrowRightIcon sx={{ padding:0, fontSize: 24, color: "#5d5d5d" }}/>
          </IconButton>
        </Button>
      </Flex>
      <NewTaskModal isTaskOpen={isTaskOpen} onClose={() => setIsTaskOpen(false)} />
    </Flex>
  );
};

const TaskBox = ({task, taskId, handleClick, disableTooltip, refreshTasks, pinnedTasks}) => {
  const navigate = useNavigate();
  const [showConfirm, setShowConfirm] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);

  const isTaskPinned = () => {
    for (let i = 0; i < pinnedTasks.length; i++) {
      if (pinnedTasks[i].id === task.id) {
        return true
      }
    }
    return false
  }

  const triggerPinTask = (taskId) => {
    console.log("Pin task", taskId)
    apiClient.post('/task-actions', {
      action: "pin_task",
      pin_task: {
        task_id: taskId,
        pin_task: !isTaskPinned()
      }
    }).then(({ data }) => {
      console.log("Task pinned",data)
      refreshTasks()
    });
  }

  const handleDelete = (taskId) => {
    console.log("Delete task", taskId)
    apiClient.post('/task-actions', {
      action: "delete_task",
      delete_task: {
        task_id: taskId
      }
    }).then(({ data }) => {
      console.log("Task deleted",data)
      refreshTasks()
    });
  }

  return (
    <Box
    key={task.id}
    display="flex"
    alignItems="center"
    role="group" 
    // justifyContent={"center"}
    // gap={1.5}
    px={0}
    py="8px"
    my="8px"
    // py={1.5}
    // my={1}
    borderRadius="md"
    cursor="pointer"
    color={task.id === taskId ? '#E7EFF9' : '#1d1d1d'}
    bg={task.id === taskId ? '#E7EFF9' : 'transparent'}
    // sx={{ visibility: 'hidden' }}
    // className="task-actions"
    onClick={(e) => {
      handleClick()
      if (e.metaKey || e.ctrlKey) {
        // Open in a new tab or window
        window.open(`/t/${task.id}`, '_blank');
      } else {
        // Navigate normally
        navigate(`/t/${task.id}`);
      }
    }}
    // _hover={{ bg: '#E7EFF9' }}
    >
      <Box marginX={task.id === taskId ? '4px' : '2px'} style={{minWidth: "24px", minHeight: "24px"}}>
        <Img src={taskLogo} boxSize="24px" padding={0}/>
      </Box>
      {
        isEditMode ? (
          <TextareaWithClose value={task.name} onClose={() => setIsEditMode(false)} task={task} refreshTasks={refreshTasks} />
        ) : (
          <TruncatedTextWithTooltip text={task.name} disableTooltip={disableTooltip} />
        )
      }
      {
        showConfirm && (
          <Box
            alignItems={"center"}
            display="none"
            _groupHover={{ display: "flex" }}
          >
            <IconButton 
              sx={{ paddingX:0, paddingY:0, "&:hover":{backgroundColor:"transparent"}}}
              onClick={(e) => {
                e.stopPropagation();
                handleDelete(task.id);
                setShowConfirm(false);
              }}
              >
              <Check sx={{ padding:0, fontSize: 18, color: "#D32F2F" }}/>
            </IconButton>
            <IconButton 
              sx={{ 
                paddingX:0, 
                paddingY:0, 
                marginLeft:"2px", 
                marginRight:"2px", 
                "&:hover":{backgroundColor:"transparent"}
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowConfirm(false);
              }}
            >
              <Close sx={{ padding:0, fontSize: 18, color: "#5d5d5d" }}/>
            </IconButton>
          </Box> 
        )
      }
      { !showConfirm && !isEditMode && (
          <Box
            alignItems={"center"}
            display="none"
            _groupHover={{ display: "flex" }}
          >
            <IconButton 
              sx={{ paddingX:0, paddingY:0, "&:hover":{backgroundColor:"transparent"}}}
              onClick={(e) => {
                  e.stopPropagation();
                  triggerPinTask(task.id);
                }
              }
            >
              {
                isTaskPinned() ? 
                  <PushPin sx={{ padding:0, fontSize: 18, color: "#5d5d5d" }}/>
                :
                  <PushPinOutlined sx={{ padding:0, fontSize: 18, color: "#5d5d5d" }}/>
              }
            </IconButton>
            <IconButton 
              sx={{ 
                paddingX:0, 
                paddingY:0,
                marginLeft:"2px", 
                "&:hover":{backgroundColor:"transparent"}
              }}
              onClick={(e) => {
                  e.stopPropagation();
                  setIsEditMode(true);
                }
              }
            >
              <EditOutlined sx={{ padding:0, fontSize: 18, color: "#5d5d5d" }}/>
            </IconButton>
            <IconButton 
              sx={{ 
                paddingX:0, 
                paddingY:0, 
                marginLeft:"2px", 
                marginRight:"2px", 
                "&:hover":{backgroundColor:"transparent"}
              }}
              onClick={(e) => {
                e.stopPropagation();
                setShowConfirm(true);
              }}
            >
              <DeleteOutlined sx={{ padding:0, fontSize: 18, color: "#D32F2F" }}/>
            </IconButton>
          </Box>
        )
      }
    </Box>
  )

}

const TextareaWithClose = ({ value, onClose, task, refreshTasks }) => {
  const [textValue, setTextValue] = useState(value);

  const handleRename = (taskId, name) => {
    if (name === value) {
      return
    }

    console.log("Rename task", taskId, name)
    apiClient.post('/task-actions', {
      action: "rename_task",
      rename_task: {
        task_id: taskId,
        name: name
      }
    }).then(({ data }) => {
      console.log("Task renamed",data)
      refreshTasks()
    });
  }
  return (
    <HStack position="relative" width="90%" height="24px">
      {/* Textarea */}
      <Textarea
        minH="unset"
        height="24px"
        lineHeight="24px"
        minWidth="unset"
        overflowX="auto"
        whiteSpace="nowrap"
        resize="none"
        value={textValue} 
        onChange={(e) => setTextValue(e.target.value)}
        placeholder="Enter your text..."
        // pr="40px"  // Add padding to prevent overlap with the button
        padding="0" 
        pl="4px"
        fontSize="14px"
        fontFamily="sans-serif"
        fontWeight="medium"
        color="#1d1d1d"
        onClick={(e) => {
          e.stopPropagation();
          // handleDelete(task.id);
          // setShowConfirm(false);
        }}
        sx={{
          scrollbarWidth: "none",               // Hide scrollbar in Firefox
          "&::-webkit-scrollbar": { display: "none" }  // Hide scrollbar in Chrome/Safari
        }}
      />

      <Box
        alignItems={"center"}
        display="none"
        _groupHover={{ display: "flex" }}
      >
        <IconButton 
          sx={{ paddingX:0, paddingY:0, "&:hover":{backgroundColor:"transparent"}}}
          onClick={(e) => {
            e.stopPropagation();
            handleRename(task.id, textValue);
            onClose()
          }}
          >
          <Check sx={{ padding:0, fontSize: 18, color: "#D32F2F" }}/>
        </IconButton>
        <IconButton 
          sx={{ 
            paddingX:0, 
            paddingY:0, 
            marginLeft:"2px", 
            marginRight:"2px", 
            "&:hover":{backgroundColor:"transparent"}
          }}
          onClick={(e) => {
            e.stopPropagation();
            onClose()
          }}
        >
          <Close sx={{ padding:0, fontSize: 18, color: "#5d5d5d" }}/>
        </IconButton>
      </Box> 
    </HStack>
  );
};

const TruncatedTextWithTooltip = ({ text, disableTooltip }) => {
  const textRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useEffect(() => {
    if (textRef.current) {
      setIsTruncated(textRef.current.offsetWidth < textRef.current.scrollWidth);
    }
  }, [text]);
  
  useEffect(() => {
    if (disableTooltip == true) {
      setIsTruncated(false)
    } else {
      if (textRef.current) {
        setIsTruncated(textRef.current.offsetWidth < textRef.current.scrollWidth);
      }
    }
  }, [disableTooltip])

  return (
    <Tooltip label={text} 
      placement='top'
      isDisabled={!isTruncated}
      bg={"#8d8d8d"}
      color={"#f2f2f2"}
      fontWeight={500}
      fontFamily="'Inter', sans-serif" 
      offset={[0, -3]}
      >
      <Text 
        ref={textRef}
        fontWeight="medium" 
        color="#1d1d1d" 
        fontSize="14px" 
        fontFamily="sans-serif" 
        paddingTop="2.1px" 
        paddingLeft={"4px"} 
        paddingRight={"8px"} 
        isTruncated
      >{text}</Text>
    </Tooltip>
  );
};


export default LeftMenu;
